import {
    CMP, CMP_ADD_CONSENT_COOKIE,
    CMP_ADD_CONSENT_COOKIE_OLD, CMP_CUS_CONSENT_COOKIE,
    CMP_META_COOKIE, CMP_META_COOKIE_OLD,
    CMP_NORMAL_EXPIRED_DAYS,
    CMP_SS_COOKIE, CMP_SS_COOKIE_COPY_OLD,
    CMP_SS_COOKIE_OLD
} from "./cmp";
import {log} from "../util/log";
import cmpConfig from "../cmp-config";
import cookies from "services-comun/modules/browser/cookies";
import {VendorList} from "../model/vendor-list";
import {TCString} from "../tcstring/t-c-string";
import {AddtlConsent} from "../addtl-consent/addtl-consent";
import {UserSelection} from "../user-selection";
import {instantiate, site} from "../context/context";
import {CMPFull} from "./cmp-full";
import {CustomConsent} from "../custom-consent/custom-consent";

interface ICurrentInfo {
    in_navigator: boolean;
    info:IBasicData;
}

interface IBasicData {
    tc_string?: string;
    addtl_consent?: string;
    custom_consent?: string;
}

export class CMPProxy extends CMP {
    /* STATIC */

    /* INSTANCE */
    private _currentInfo: ICurrentInfo|undefined;
    private _defaultTCString: TCString|undefined
    private _defaultAddtlConsent: AddtlConsent|undefined;
    private _defaultCustomConsent: CustomConsent|undefined;

    public constructor() {
        super();
        log.debug('CMP Proxy created.');
    }

    public get defaultTCString() : TCString|undefined {
        return this._defaultTCString;
    }

    protected set defaultTCString(defaultTCString: TCString|undefined) {
        this._defaultTCString = defaultTCString;
    }

    public get defaultAddtlConsent() : AddtlConsent|undefined {
        return this._defaultAddtlConsent;
    }

    protected set defaultAddtlConsent(defaultAddtlConsent: AddtlConsent|undefined) {
        this._defaultAddtlConsent = defaultAddtlConsent;
    }

    public get defaultCustomConsent() : CustomConsent|undefined {
        return this._defaultCustomConsent;
    }

    protected set defaultCustomConsent(defaultCustomConsent: CustomConsent|undefined) {
        this._defaultCustomConsent = defaultCustomConsent;
    }

    public async load(): Promise<void> {
        log.debug('Loading CMP Proxy instance...');
        const currentInfo = await this.loadInfo();

        this.vendorList = new VendorList();
        let encodedTCString: string|undefined = undefined;
        let encodedAddtlConsent: string|undefined = undefined;
        let encodedCustomConsent: string|undefined = undefined;

        if (currentInfo.in_navigator) {
            encodedTCString = currentInfo.info.tc_string;
            encodedAddtlConsent = currentInfo.info.addtl_consent?.trim();
            encodedCustomConsent = currentInfo.info.custom_consent?.trim();
            this.consentAcquired = true;
        }
        this.tcString = TCString.buildProxy(encodedTCString);
        this.addtlConsent = AddtlConsent.buildProxy(encodedAddtlConsent);
        this.customConsent = site.hashCustomConfig() ? CustomConsent.buildProxy(encodedCustomConsent) : undefined;
        this.defaultTCString = TCString.buildProxy(site.defaultConsentString);
        this.defaultAddtlConsent = AddtlConsent.buildProxy(site.defaultAddtlConsent);
        this.defaultCustomConsent = site.hashCustomConfig() ? CustomConsent.buildProxy(site.defaultCustomConsent) : undefined;

        if (!currentInfo.in_navigator) {
            this.tcString.coreString().vendorListVersion = this.defaultTCString.coreString().vendorListVersion;
            this.tcString.coreString().tcfPolicyVersion = this.defaultTCString.coreString().tcfPolicyVersion;
            this.vendorList.proxyLoad(this.defaultTCString, this.defaultAddtlConsent, this.defaultCustomConsent);
        } else {
            this.vendorList.proxyLoad(this.tcString, this.addtlConsent, this.customConsent);
        }
        this.userSelection = new UserSelection();
        log.debug('CMP Proxy loaded.');
    }

    private async loadInfo() : Promise<ICurrentInfo> {
        log.debug('Checking current info por CMP Proxy...');
        // Eliminamos Cookies obsoletas
        if (cookies.get(CMP_SS_COOKIE_COPY_OLD)) cookies.remove(CMP_SS_COOKIE_COPY_OLD);
        if (!this._currentInfo) {

            // Hacemos una migración previa de las cookies de la versión anterior a la nueva
            const tcStringOld: string|undefined = cookies.get(CMP_SS_COOKIE_OLD);
            const tcStringNew: string|undefined = cookies.get(CMP_SS_COOKIE);
            const addtlConsentOld: string|undefined = cookies.get(CMP_ADD_CONSENT_COOKIE_OLD);
            const addtlConsentNew: string|undefined = cookies.get(CMP_ADD_CONSENT_COOKIE);
            const cmpCLOld: string|undefined = cookies.get(CMP_META_COOKIE_OLD);
            const cmpCLNew: string|undefined = cookies.get(CMP_META_COOKIE);

            const expiration:number = Date.now() +CMP_NORMAL_EXPIRED_DAYS * 24 * 60 * 60 * 1000;

            if (tcStringOld && !tcStringNew) {
                cookies.set(CMP_SS_COOKIE, tcStringOld, new Date(expiration));
                cookies.remove(CMP_SS_COOKIE_OLD);
            }

            if (addtlConsentOld) {
                cookies.remove(CMP_ADD_CONSENT_COOKIE_OLD);
                cookies.remove(CMP_SS_COOKIE_COPY_OLD);
            }
            if (addtlConsentNew) {
                cookies.remove(CMP_ADD_CONSENT_COOKIE);
            }

            let addtlCookieValue = addtlConsentOld || addtlConsentNew;
            if (addtlCookieValue) {
                const addtlConsent = AddtlConsent.buildProxy(addtlCookieValue);
                addtlConsent.save();
            } else {
                addtlCookieValue = AddtlConsent.getString();
            }

            // if (addtlConsentOld && !addtlConsentNew) {
            //     cookies.set(CMP_ADD_CONSENT_COOKIE, addtlConsentOld, new Date(expiration));
            //     cookies.remove(CMP_ADD_CONSENT_COOKIE_OLD);
            //     cookies.remove(CMP_SS_COOKIE_COPY_OLD);
            // }

            if (cmpCLOld && !cmpCLNew) {
                cookies.set(CMP_META_COOKIE, cmpCLOld, new Date(expiration));
                cookies.remove(CMP_META_COOKIE_OLD);
            }

            let info: ICurrentInfo;
            if (cmpConfig.serviceSpecific && cookies.get(CMP_SS_COOKIE) && addtlCookieValue && (site.hashCustomConfig() ? !!cookies.get(CMP_CUS_CONSENT_COOKIE) : true)) {
                info = {
                    in_navigator: true,
                    info: {
                        tc_string: cookies.get(CMP_SS_COOKIE),
                        addtl_consent: addtlCookieValue,
                        custom_consent: site.hashCustomConfig() ? cookies.get(CMP_CUS_CONSENT_COOKIE) : undefined
                    }
                };
            } else if (cmpConfig.serviceSpecific) {
                log.debug('No data available in navigator for CMP Proxy. Loading default data...');
                info = {
                    in_navigator: false,
                    info: {
                        tc_string: site.defaultConsentString,
                        addtl_consent: site.defaultAddtlConsent,
                        custom_consent: site.defaultCustomConsent
                    }
                };
                log.debug('Default data loaded for CMP Proxy');
            } else {
                log.debug('CurrentInfo for CMP Proxy not loaded. Error.')
                return Promise.reject();
            }
            this._currentInfo = info;
        }
        return this._currentInfo;
    }

    public override async unproxy(): Promise<CMP> {
        const full: CMPFull = new CMPFull(this.consentAcquired, this.tcString, this.addtlConsent, this.customConsent);
        instantiate(full);
        await full.load();
        return full;
    }

    public override acceptAll(): void {
        // Ponemos la addtl-consent por defecto
        this.addtlConsent = this._defaultAddtlConsent;

        // Ponemos la TcString por defecto
        this.tcString = this._defaultTCString;

        // Ponemos la custom-consent por defecto
        this.customConsent = this._defaultCustomConsent;

        super.acceptAll();
    }

    public saveAndAcceptConfiguration() : void {
        throw new Error(`Not possible`);
    }
}
